import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SetpointsDetail from './SetpointsDetail';
import { getSetpoints, getUserProfileWidget, getCurrentTimezone } from '../../selectors/index';
import { describeSetpointsThunk, saveSetpointsThunk, setSetpointsChangeThunk } from '../../actions/setpoints';

const mapStateToProps = state => {
  return {
    setpoints: getSetpoints(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      describeSetpoints: (setpointId, modelCategoryId, widgetCode) => describeSetpointsThunk(setpointId, modelCategoryId,widgetCode),
      changeSetpoints: setpoint => setSetpointsChangeThunk(setpoint),
      saveSetpoints: (setpoint, widgetCode) => saveSetpointsThunk(setpoint, widgetCode)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SetpointsDetail);
